<div class="container-fluid pb-3 pt-2">
  <h4 class="mb-2">{{headingText}}</h4>
  <div *ngIf="!loading; else loader">
    <mat-accordion>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Ricerca
          </mat-panel-title>
          <mat-panel-description>
            Ricerca avanzata per modelli
          </mat-panel-description>
        </mat-expansion-panel-header>
        <ricerca-models [(search)]="search"></ricerca-models>
      </mat-expansion-panel>
    </mat-accordion>

    <button mat-raised-button color="primary" class="my-4" (click)="add()">
      Aggiungi un modello compagnia<mat-icon>add</mat-icon>
    </button>
    
    <resourceful-index #index 
  [search]="search" 
  [modelService]="modelloCompagniaService" 
  [deleteFunction]='deleteFunction' 
  [notShowDelete]="isUserAdmin()"
  [columnDefinitions]="columnDefinitions" 
  [editFunction]="editFunction" 
  [downloadFunction]="downloadFunction" 
  [selectionMode]="selectionMode"
  (selectedModel)="closeDialogWithSelectedModel($event)" 
  [relations]="relations">
</resourceful-index>

  </div>
  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>